module.exports = __webpack_public_path__ + "static/media/NOR.a0cf93aa.svg";